import { render, staticRenderFns } from "./SubTagView.vue?vue&type=template&id=c9782b2e&scoped=true"
import script from "./SubTagView.vue?vue&type=script&lang=js"
export * from "./SubTagView.vue?vue&type=script&lang=js"
import style0 from "./SubTagView.vue?vue&type=style&index=0&id=c9782b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9782b2e",
  null
  
)

export default component.exports